import {
  Bell,
  CreditCard,
  FolderKanban,
  ListChecks,
  type LucideIcon,
  Plug,
  ScrollText,
  Settings,
  Users,
} from "lucide-react";

export interface WorkspaceNavItem {
  id: string;
  label: string;
  icon: LucideIcon;
}

/** The guided first run. Listed in the sidebar only until its three steps are done. */
export const GET_STARTED = "get-started";

export const workspaceNav: WorkspaceNavItem[] = [
  { id: GET_STARTED, label: "Get started", icon: ListChecks },
  { id: "projects", label: "Projects", icon: FolderKanban },
  { id: "connections", label: "Connections", icon: Plug },
  { id: "members", label: "Members & access", icon: Users },
  { id: "channels", label: "Channels", icon: Bell },
  { id: "billing", label: "Billing & usage", icon: CreditCard },
  { id: "audit", label: "Audit log", icon: ScrollText },
  { id: "settings", label: "Settings", icon: Settings },
];
